export default class ClubMemberAccessMediumAssignmentJob {

    static fromData(data) {
        if (!data) {
            return;
        }

        let clubMemberAccessMediumAssignmentJob = new ClubMemberAccessMediumAssignmentJob();
        clubMemberAccessMediumAssignmentJob.id = data.id;
        clubMemberAccessMediumAssignmentJob.memberId = data.memberId;
        clubMemberAccessMediumAssignmentJob.memberName = data.memberName;
        clubMemberAccessMediumAssignmentJob.validUntil = new Date(data.validUntil);

        Object.seal(clubMemberAccessMediumAssignmentJob);
        return clubMemberAccessMediumAssignmentJob;
    }
}
